import React, { useState } from 'react';
import ReactPlayer from 'react-player';
import { useTranslation } from 'react-i18next';
import deTexts from './HappyCubeDe.json';
import enTexts from './HappyCubeEn.json';
import styles from './HappyCube.module.css';
import happyCubeFace from './images/20250407_144612.jpg';
import happyCubeText from './images/20250407_144617.jpg';
import happyCubeTime from './images/20250407_144609.jpg';

const HappyCube = () => {
    const { i18n } = useTranslation();
    const currentLang = i18n.language;
    const texts = currentLang.startsWith('de') ? deTexts : enTexts;

    // Definiere die Medien-Slides (Bild und Video)
    const slides = [
        {
            type: 'image',
            src: happyCubeFace,
            alt: texts.imageFaceAlt || 'Happy Cube Image'
        },
        {
            type: 'image',
            src: happyCubeText,
            alt: texts.imageTextAlt || 'Happy Cube Image'
        },
        {
            type: 'image',
            src: happyCubeTime,
            alt: texts.imageTimeAlt || 'Happy Cube Image'
        },
        // {
        //     type: 'video',
        //     url: 'https://www.youtube.com/watch?v=LXb3EKWsInQ',
        //     title: texts.videoTitle || 'Happy Cube Video'
        // }
    ];

    const [currentSlideIndex, setCurrentSlideIndex] = useState(0);

    const handlePrev = () => {
        setCurrentSlideIndex(prev => prev === 0 ? slides.length - 1 : prev - 1);
    };

    const handleNext = () => {
        setCurrentSlideIndex(prev => prev === slides.length - 1 ? 0 : prev + 1);
    };

    return (
        <div className={styles.happyCube} id="happyCube">
            <div className={styles.content}>
                <div className={styles.mediaWrapper}>
                    <div className={styles.slider}>
                        <button
                            className={styles.arrowLeft}
                            onClick={handlePrev}
                            aria-label="Vorheriges Medium">
                            ◀
                        </button>
                        <div className={styles.media}>
                            {slides[currentSlideIndex].type === 'image' ? (
                                <img
                                    src={slides[currentSlideIndex].src}
                                    alt={slides[currentSlideIndex].alt}
                                    className={styles.mediaContent}
                                />
                            ) : (
                                <ReactPlayer
                                    url={slides[currentSlideIndex].url}
                                    className={styles.mediaContent}
                                    width="100%"
                                    height="100%"
                                    controls
                                />
                            )}
                        </div>
                        <button
                            className={styles.arrowRight}
                            onClick={handleNext}
                            aria-label="Nächstes Medium">
                            ▶
                        </button>
                    </div>
                    <div className={styles.indicator}>
                        {currentSlideIndex + 1}/{slides.length}
                    </div>
                </div>
                <div className={styles.description}>
                    <h2>{texts.title || 'Happy Cube'}</h2>
                    <p>{texts.description}</p>
                    <a
                        href="https://github.com/d0ener4ever/HappyCube/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        GitHub Repository
                    </a>
                </div>
            </div>
        </div>
    );
};

export default HappyCube;
